/**
 * Simple view preference utilities for process flow display
 */

/**
 * Get user's preferred view mode from localStorage
 */
export function getUserViewPreference(): 'list' | 'flow' | null {
  try {
    const preference = localStorage.getItem('processFlowViewMode');
    if (preference === 'list' || preference === 'flow') {
      return preference;
    }
  } catch {
    // Ignore localStorage errors
  }
  return null;
}

/**
 * Save user's view mode preference
 */
export function saveUserViewPreference(mode: 'list' | 'flow'): void {
  try {
    localStorage.setItem('processFlowViewMode', mode);
  } catch {
    // Ignore localStorage errors
  }
}

